import { Feature, UserFeatureToggleConfig } from './constants';
import {
  getNonLiveStaticToggleOverrideValue,
  isFeatureEnabled as isFeatureEnabledBase,
} from './utils';
import { config } from '@shopee-user/platform';
import { NON_LIVE_STATIC_TOGGLE_OVERRIDE_CONFIG } from './nonLiveStaticToggleOverrideConfig';
import { STATIC_FEATURE_TOGGLE_OVERRIDE_SESSION_STORAGE_KEY } from '@tob/shared/devtool/constants';

const { ENV, LOCALE } = config;

function isNonLiveFeatureEnabled(
  feature: Feature,
  defaultValue: boolean
): boolean {
  let nonLiveStaticToggleDynamicOverrideValue;
  const nonLiveStaticToggleDynamicOverrideConfigString = sessionStorage.getItem(
    STATIC_FEATURE_TOGGLE_OVERRIDE_SESSION_STORAGE_KEY
  );

  if (nonLiveStaticToggleDynamicOverrideConfigString) {
    try {
      const nonLiveStaticToggleDynamicOverrideConfig = JSON.parse(
        nonLiveStaticToggleDynamicOverrideConfigString
      );
      nonLiveStaticToggleDynamicOverrideValue =
        nonLiveStaticToggleDynamicOverrideConfig[feature];
    } catch (e) {
      // silently fail
    }
  }

  const nonLiveStaticToggleOverrideValue = getNonLiveStaticToggleOverrideValue(
    feature,
    NON_LIVE_STATIC_TOGGLE_OVERRIDE_CONFIG,
    LOCALE
  );

  // Dynamic Override is higest priority
  if (typeof nonLiveStaticToggleDynamicOverrideValue === 'boolean') {
    return nonLiveStaticToggleDynamicOverrideValue;
  }

  // Harcoded Override is second Highest Priority
  if (typeof nonLiveStaticToggleOverrideValue === 'boolean') {
    return nonLiveStaticToggleOverrideValue;
  }

  return isFeatureEnabledBase<Feature>(feature, UserFeatureToggleConfig, {
    defaultValue,
    env: ENV,
    locale: LOCALE,
  });
}

function isLiveFeatureEnabled(
  feature: Feature,
  defaultValue: boolean
): boolean {
  return isFeatureEnabledBase<Feature>(feature, UserFeatureToggleConfig, {
    defaultValue,
    env: ENV,
    locale: LOCALE,
  });
}

const isFeatureEnabled =
  ENV === 'live' ? isLiveFeatureEnabled : isNonLiveFeatureEnabled;

export {
  // Enum
  Feature,
  // Constants
  UserFeatureToggleConfig,
  // Utils
  isFeatureEnabled,
};
